/**
 * アクティベーションファイルのダウンロード時の確認ダイアログのPresentation Component
 */
import React from 'react';
import { Button, Popup, Title } from 'common/components';
import { BoardGL, Glossary } from 'common/utils/glossary';

interface ConfirmationBoardProps {
  /** ActFileDownloadConfirmationBoardの表示有無 */
  isDisplay: boolean;
  /** グロッサリ */
  glossary: Glossary;
  /** "閉じるボタン"(×)、"いいえボタン"の処理 */
  onClickClose: () => void;
  /** "はいボタン"の処理 */
  onClickYes: () => void;
}

export const ActFileDownloadConfirmationBoard: React.FC<ConfirmationBoardProps> = ({
  isDisplay,
  glossary,
  onClickClose,
  onClickYes
}) => {
  const _component = (
    <Popup
      className="actFileDownloadConfirmationBoard-popup"
      onClickBackground={onClickClose}
      data-test="actFileDownloadConfirmationBoard-popup"
      visible={isDisplay}
    >
      <div className="actFileDownloadConfirmationBoard">
        <Button
          type="toolButton"
          subType="close"
          data-test="actFileDownloadConfirmationBoard-toolButton"
          onClick={onClickClose}
        />
        <Title type="title" data-test="actFileDownloadConfirmationBoard-title">
          {glossary.glx(BoardGL.ActFileDownload)}
        </Title>
        <div className="actFileDownloadConfirmationBoard-confirm">
          <Title
            type="listMessage"
            data-test="actFileDownloadConfirmationBoard-listMessage-1"
          >
            {glossary.glx(BoardGL.ActFileDownloadConfirmation)}
          </Title>
          <Title
            type="listMessage"
            data-test="actFileDownloadConfirmationBoard-listMessage-2"
          >
            {glossary.glx(BoardGL.ActFileDownloadConfirmationCopyToMemoryCard)}
          </Title>
        </div>
        <ul className="actFileDownloadConfirmationBoard-confirm-list">
          <li data-test="actFileDownloadConfirmationBoard-confirm-list-1">
            {glossary.glx(BoardGL.ActFileDownloadConfirmationCouldNotCanceled)}
          </li>
          <li data-test="actFileDownloadConfirmationBoard-confirm-list-2">
            {glossary.glx(BoardGL.ActFileDownloadConfirmationOneFile)}
          </li>
          <li data-test="actFileDownloadConfirmationBoard-confirm-list-3">
            {glossary.glx(BoardGL.ActFileDownloadConfirmationRepeatedly)}
          </li>
        </ul>
        <div className="actFileDownloadConfirmationBoard-buttonContainer">
          <Button
            type="downloadButton"
            data-test="actFileDownloadConfirmationBoard-yesButton"
            onClick={onClickYes}
          >
            {glossary.glx(BoardGL.Download)}
          </Button>
          <Button
            type="cancelButton"
            data-test="actFileDownloadConfirmationBoard-noButton"
            onClick={onClickClose}
          >
            {glossary.glx(BoardGL.Canceled)}
          </Button>
        </div>
      </div>
    </Popup>
  );
  return isDisplay ? _component : null;
};

export default ActFileDownloadConfirmationBoard;
